import { render, staticRenderFns } from "./RoamingForm.vue?vue&type=template&id=3b318284&scoped=true"
import script from "./RoamingForm.vue?vue&type=script&lang=js"
export * from "./RoamingForm.vue?vue&type=script&lang=js"
import style0 from "./RoamingForm.vue?vue&type=style&index=0&id=3b318284&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b318284",
  null
  
)

export default component.exports